<template>
    <div :class="['navbar-area', { 'is-sticky': isSticky }]">
        <div class="meander_software-nav">
            <div class="container">
                <nav class="navbar navbar-expand-lg navbar-light bg-light flex-nowrap">
                    <router-link class="navbar-brand" to="/" v-if="!active">
                        <img src="../../assets/images/newlogo.png" alt="logo" width="160" height="35" loading="eager" decoding="async">
                        <img src="../../assets/images/black-logo.png" alt="logo" width="160" height="35" loading="eager" decoding="async">
                    </router-link>


                    <div class="collapse navbar-collapse gap-4 justify-content-start  d-flex justify-content-center" :class="{ show: active }">
                        <!-- Desktop Menu -->
                        <ul class="navbar-nav m-0 header-new d-none d-lg-flex">

                            <li class="nav-item megamenu">
                                <router-link to="/" class="nav-link">Models</router-link>
                                 
                                <ul class="dropdown-menu" v-if="appCategories?.length">
                                    <li class="nav-item">
                                        <div class="container">
                                            <div class="row">
                                                <div class="col"
                                                    v-for="(category, categoryIndex) in sortedAppCategories"
                                                    :key="category.slug">
                                                    <h6 class="submenu-title">{{ category.name }}</h6>
                                                    <ul class="megamenu-submenu">
                                                        <li v-for="app in categoryIndex == 4 ? category.business_models.slice(0, 5) : category.business_models"
                                                            :key="app.slug">
                                                            <router-link :to="`/project/${app.slug}`"
                                                                @click="setAppsInLocalStorage(category)">{{ app?.name
                                                                }}</router-link>
                                                        </li>
                                                    </ul>
                                                    <div v-if="categoryIndex == 4 && !isHomePage " class="others-option">
                                                        <!-- <router-link to="/contact" class="default-btn">Contact</router-link> -->
                                                        <button class="default-btn py-1 mt-2"
                                                            @click="$router.push('/')">See All</button>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                            <li class="nav-item megamenu">
                                <a href="#" class=" nav-link">Products</a>
                                <ul class="dropdown-menu products-dropdown-menu">
                                    <li class="nav-item">
                                        <div class="container">
                                            <div class="row">
                                                <!-- Column 1: Build With Meander (Appears first on desktop, second on mobile) -->
                                                <div class="col-lg-3 col-md-12 order-lg-1 order-2 mb-4 mb-lg-0 mobile-divider">
                                                    <h6 class="submenu-title">Build With Meander</h6>
                                                    <router-link to="/build-with-meander" class="product-img-link-new">
                                                        <img src="/build-with-meander.svg" alt="Build With Meander" class="img-fluid nav-product-img" />
                                                    </router-link>
                                                </div>

                                                <!-- Column 2: Grow With Meander (Appears second on desktop, third on mobile) -->
                                                <div class="col-lg-3 col-md-12 order-lg-2 order-3 mb-4 mb-lg-0">
                                                    <h6 class="submenu-title">Grow With Meander</h6>
                                                    <router-link to="/grow-with-meander" class="product-img-link-new">
                                                        <img src="/grow-with-meander-new.jpeg" alt="Grow With Meander" class="img-fluid nav-product-img" />
                                                    </router-link>
                                                </div>

                                                <!-- Column 3: Our Products split into 2 sub-columns (Appears third on desktop, first on mobile) -->
                                                <div class="col-lg-6 col-md-12 order-lg-3 order-1 ps-lg-4 mb-4 mb-lg-0">
                                                    <div class="row">
                                                        <!-- Sub-column 1 -->
                                                        <div class="col-md-6 col-sm-12">
                                                            <h6 class="submenu-title">Products</h6>
                                                            <ul class="megamenu-submenu">
                                                                <li v-for="product in sortedProducts" :key="product.slug">
                                                                    <router-link :to="`/project/${product?.slug}`">{{ product?.name }}</router-link>
                                                                </li>
                                                              
                                                                <li>
                                                                    <router-link to="/project/food-ordering-app">Fringle</router-link>
                                                                </li>
                                                                <li>
                                                                    <router-link to="/project/real-estate-app">Argile</router-link>
                                                                </li>
                                                                <li>
                                                                    <router-link to="/project/netflix-clone">Copepod</router-link>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <!-- Sub-column 2 -->
                                                        <div class="col-md-6 col-sm-12">
                                                            <h6 class="submenu-title">Services</h6>
                                                            <ul class="megamenu-submenu">
                                                                <li>
                                                                    <router-link to="/project/full-stack-web-app-development">Web Development</router-link>
                                                                </li>
                                                                <li>
                                                                    <router-link to="/project/mobile-app-design-and-development">Mobile Apps</router-link>
                                                                </li>
                                                                <li>
                                                                    <router-link to="/project/performance-driven-digital-marketing">Digital Marketing</router-link>
                                                                </li>
                                                                <li>
                                                                    <router-link to="/project/no-code-mvp-builder-and-prototyping">MVP Building</router-link>
                                                                </li>
                                                                <li>
                                                                    <router-link to="/project/workflow-automation-and-tool-integration">Automation</router-link>
                                                                </li>
                                                                <li>
                                                                    <router-link to="/project/advertising-and-campaign-integration">Campaign management</router-link>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                            <li class="nav-item">
                                <router-link to="/projects?type=Integration" class="nav-link">Integration</router-link>
                                <ul class="dropdown-menu">
                                    <li class="nav-item" v-for="integration in integration" :key="integration.slug">
                                        <router-link :to="`/project/${integration?.slug}`" TeamTwo class="nav-link">{{
                                            integration?.name }}</router-link>
                                    </li>



                                </ul>
                            </li>
                            <li class="nav-item">
                                <router-link to="/projects?type=Plug n Play" class="nav-link">Plug n Play</router-link>
                                <ul class="dropdown-menu">
                                    <li class="nav-item" v-for="integration in plugnplay" :key="integration.slug">
                                        <router-link :to="`/project/${integration?.slug}`" TeamTwo class="nav-link">{{
                                            integration?.name }}</router-link>
                                    </li>



                                </ul>
                            </li>
                            <!-- <li class="nav-item">
                                <router-link to="/projects?type=Integration" class="nav-link">Integration</router-link>
                            </li> -->
                            <!-- <li class="nav-item">
                                <router-link to="/projects?type=Plug n Play" class="nav-link">Plug n Play</router-link>
                            </li> -->
                            <li class="nav-item">
                                <router-link to="/resources" class="nav-link">Resources</router-link>
                            </li>




                        </ul>

                        <transition name="fade-slide ">
                            <aside v-if="showAside" class="d-none d-lg-block widget-area left-sidebar w-40">
                                <div class="widget widget_search">
                                    <form class="search-form">
                                        <label class="search-container">
                                            <input type="search" class="search-field" placeholder="Search..."
                                                v-model="searchQuery" @input="handleSearch"
                                                @focus="showSearchResults = true" @blur="handleBlur">
                                            <button type="button">
                                                <svg fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 16 16" width="16px" height="16px">
                                                    <path
                                                        d="M13.438,15.563l-2.665-2.664	C9.684,13.598,8.388,14.002,7,14.002c-3.865,0-7-3.135-7-7c0-3.864,3.135-7,7-7c3.864,0,7,3.136,7,7	c0,1.391-0.407,2.687-1.105,3.776l2.665,2.664c0.585,0.585,0.585,1.536,0,2.121C14.974,16.148,14.024,16.148,13.438,15.563z M12,7.002c0-2.759-2.241-5-5-5c-2.76,0-5,2.241-5,5c0,2.76,2.24,5,5,5C9.759,12.002,12,9.762,12,7.002z" />
                                                </svg>
                                            </button>
                                            <!-- Search Results Dropdown -->
                                            <div v-if="showSearchResults && filteredApps.length > 0"
                                                class="search-results-dropdown">
                                                <div v-for="app in filteredApps" :key="app.slug"
                                                    class="search-result-item" @mousedown.prevent="navigateToApp(app.slug)">
                                                    {{ app.name }}
                                                </div>
                                            </div>
                                        </label>
                                    </form>
                                </div>
                            </aside>
                        </transition>
                    </div>
                    <transition name="fade-slide" v-if="!active" class="d-lg-none">
                        <aside v-if="showAside" class="widget-area left-sidebar w-40 m-0">
                            <div :class="` ${isContect ? 'bg-tran' : ''} widget widget_search`">
                                <form :class="`search-form d-none   d-lg-block`" @submit.prevent>
                                    <label class="search-container">
                                        <input type="search" class="search-field" placeholder="Search..."
                                            v-model="searchQuery" @input="handleSearch"
                                            @focus="showSearchResults = true" @blur="handleBlur">

                                        <div v-if="showSearchResults && filteredApps.length > 0"
                                            class="search-results-dropdown">
                                            <div v-for="app in filteredApps" :key="app.slug" class="search-result-item"
                                                @mousedown.prevent="navigateToApp(app.slug)">
                                                {{ app.name }}
                                            </div>
                                        </div>
                                    </label>
                                </form>
                                <form :class="`search-form ${isContect ? 'd-block' : 'd-none'} d-md-none`"
                                    @submit.prevent>

                                    <!-- <i @click="handleSearchIconClick() " class="ri-search-2-line Sreach-icon"></i> -->
                                    <img @click="handleSearchIconClick()" src="../../assets/images/icons-search-nav.svg"
                                        alt="search icon" width="25px" height="25px" class="Sreach-icon">
                                </form>
                            </div>
                        </aside>
                    </transition>
                    <div class="gap-3 d-flex align-items-center">
                        <div :class="`others-opti  d-block `" v-if="!active">
                            <router-link class="default-btn ms-2 contact-btn" to="/build-with-meander">Grow</router-link>


                        </div>



                        <div :class="`navbar-toggler ${!active ? 'd-block  ' : 'd-none'} d-lg-none`"
                            @click="toggleMobileMenu" :aria-pressed="active ? 'true' : 'false'"
                            v-bind:class="{ 'active': button_active_state }">
                            <span class="icon-bar top-bar"></span>
                            <span class="icon-bar middle-bar"></span>
                            <span class="icon-bar bottom-bar"></span>
                        </div>

                    </div>


                </nav>
            </div>
        </div>


        <div style="    padding: 10px 10px 0px;
    position: absolute;
    width: 100%;
    top: 66px;" v-if="showAside" class="d-block d-md-none">
            <transition name="fade-slide" v-if="!active" class="d-lg-none">
                <aside class="widget-area left-sidebar w-100 m-0">
                    <div :class="` ${isContect ? 'bg-tran' : ''} widget widget_search`">
                        <form :class="`search-form ${isContect ? 'd-none' : 'd-block'}  `"
                            style="border: 1px solid #989898c7; border-radius: 10px;" @submit.prevent>
                            <label class="search-container">
                                <input type="search" class="search-field" placeholder="Search..." v-model="searchQuery"
                                    @input="handleSearch" @focus="showSearchResults = true" @blur="handleBlur">
                                <!-- <button type="button"><i class="ri-search-2-line"></i></button> -->
                                <!-- Search Results Dropdown -->
                                <div v-if="showSearchResults && filteredApps.length > 0"
                                    class="search-results-dropdown">
                                    <div v-for="app in filteredApps" :key="app.slug" class="search-result-item"
                                        @mousedown.prevent="navigateToApp(app.slug)">
                                        {{ app.name }}
                                    </div>
                                </div>
                            </label>
                        </form>

                    </div>
                </aside>
            </transition>
        </div>

        <!-- Mobile Offcanvas Menu -->
        <transition name="offcanvas">
            <div v-if="active" class="mobile-offcanvas-overlay d-lg-none" @click="closeMobileMenu"></div>
        </transition>
        <transition name="offcanvas-slide">
            <aside v-if="active" class="mobile-offcanvas d-lg-none">
                <!-- Offcanvas Header -->
                <div class="offcanvas-header">
                    <router-link class="offcanvas-logo" to="/" @click="closeMobileMenu">
                        <img src="../../assets/images/newlogo.png" alt="logo">
                    </router-link>
                    <button class="offcanvas-close" @click="closeMobileMenu" aria-label="Close menu">
                        <i class="ri-close-line"></i>
                    </button>
                </div>

                <!-- Offcanvas Body -->
                <div class="offcanvas-body">
                    <!-- Profile Section -->
                    <div class="offcanvas-section">
                        <h6 class="offcanvas-section-title">Discover</h6>
                        <ul class="offcanvas-menu">
                            <!-- <li class="offcanvas-menu-item">
                             <router-link to="/" @click="closeMobileMenu" class="offcanvas-menu-link">
                                 <i class="ri-home-line"></i>
                                 <span>Home</span>
                             </router-link>
                         </li>
                         <li class="offcanvas-menu-item">
                             <router-link to="/projects" @click="closeMobileMenu" class="offcanvas-menu-link" active-class="router-link-active">
                                 <i class="ri-menu-line"></i>
                                 <span>Programs</span>
                             </router-link>
                         </li> -->
                            <li class="offcanvas-menu-item">
                                <a href="#" class="offcanvas-menu-link" @click.prevent="toggleAccordion('models')">
                                    <i class="ri-apps-line"></i>
                                    <span>Models</span>
                                    <i class="ri-arrow-down-s-line ms-auto"
                                        :class="expandedMenuItems.models ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
                                </a>
                                <ul class="offcanvas-submenu" v-if="expandedMenuItems.models && appCategories?.length">
                                    <li v-for="(category, categoryIndex) in sortedAppCategories" :key="category.slug">
                                        <h6 class="offcanvas-submenu-title">{{ category.name }}</h6>
                                        <ul class="offcanvas-submenu-list">
                                            <li v-for="app in categoryIndex == 4 ? category.business_models.slice(0, 5) : category.business_models"
                                                :key="app.slug">
                                                <router-link :to="`/project/${app.slug}`"
                                                    @click="closeMobileMenu(); setAppsInLocalStorage(category)">{{
                                                        app?.name
                                                    }}</router-link>
                                            </li>
                                        </ul>
                                        <div v-if="categoryIndex == 4 && !isHomePage && !isProjectsPage" class="offcanvas-see-all">
                                            <button class="default-btn py-1 mt-2"
                                                @click="closeMobileMenu(); $router.push('/projects')">See All</button>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                            <li class="offcanvas-menu-item">
                                <a href="#" class="offcanvas-menu-link"
                                    :class="{ 'active-expanded': expandedMenuItems.products }"
                                    @click.prevent="toggleAccordion('products')">
                                    <i class="ri-shopping-bag-line"></i>
                                    <span>Products</span>
                                    <i class="ri-arrow-down-s-line ms-auto"
                                        :class="expandedMenuItems.products ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
                                </a>
                                <ul class="offcanvas-submenu" v-if="expandedMenuItems.products && products?.length">
                                    <ul class="offcanvas-submenu-list">
                                        <li class="offcanvas-submenu-list-item" v-for="product in sortedProducts"
                                            :key="product.slug">
                                            <router-link :to="`/project/${product?.slug}`" @click="closeMobileMenu()"
                                                class="offcanvas-submenu-link">{{
                                                    product?.name }}</router-link>
                                        </li>
                                         <li class="offcanvas-submenu-list-item">
                                             <router-link to="/project/doctor-appointment-app" @click="closeMobileMenu()"
                                                 class="offcanvas-submenu-link">Doctor Appointment App</router-link>
                                         </li>
                                         <li class="offcanvas-submenu-list-item">
                                             <router-link to="/project/food-ordering-app" @click="closeMobileMenu()"
                                                 class="offcanvas-submenu-link">Fringle</router-link>
                                         </li>
                                         <li class="offcanvas-submenu-list-item">
                                             <router-link to="/project/real-estate-app" @click="closeMobileMenu()"
                                                 class="offcanvas-submenu-link">Argile</router-link>
                                         </li>
                                         <li class="offcanvas-submenu-list-item">
                                             <router-link to="/project/netflix-clone" @click="closeMobileMenu()"
                                                 class="offcanvas-submenu-link">Copepod</router-link>
                                         </li>
                                        <li class="offcanvas-submenu-list-item">
                                            <router-link to="/project/build-with-meander" @click="closeMobileMenu()"
                                                class="offcanvas-submenu-link">Build With Meander</router-link>
                                        </li>
                                        <li class="offcanvas-submenu-list-item">
                                            <router-link to="/grow-with-meander" @click="closeMobileMenu()"
                                                class="offcanvas-submenu-link">Grow With Meander</router-link>
                                        </li>
                                    </ul>
                                </ul>
                            </li>
                            <li class="offcanvas-menu-item">
                                <a href="#" class="offcanvas-menu-link"
                                    :class="{ 'active-expanded': expandedMenuItems.integration }"
                                    @click.prevent="toggleAccordion('integration')">
                                    <i class="ri-plug-line"></i>
                                    <span>Integration</span>
                                    <i class="ri-arrow-down-s-line ms-auto"
                                        :class="expandedMenuItems.integration ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
                                </a>
                                <ul class="offcanvas-submenu"
                                    v-if="expandedMenuItems.integration && integration?.length">
                                    <ul class="offcanvas-submenu-list">
                                        <li class="offcanvas-submenu-list-item" v-for="item in integration"
                                            :key="item.slug">
                                            <router-link :to="`/project/${item?.slug}`" @click="closeMobileMenu()"
                                                class="offcanvas-submenu-link">{{
                                                    item?.name }}</router-link>
                                        </li>
                                    </ul>
                                </ul>
                            </li>
                            <li class="offcanvas-menu-item">
                                <a href="#" class="offcanvas-menu-link"
                                    :class="{ 'active-expanded': expandedMenuItems.plugnplay }"
                                    @click.prevent="toggleAccordion('plugnplay')">
                                    <i class="ri-play-circle-line"></i>
                                    <span>Plug n Play</span>
                                    <i class="ri-arrow-down-s-line ms-auto"
                                        :class="expandedMenuItems.plugnplay ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
                                </a>
                                <ul class="offcanvas-submenu" v-if="expandedMenuItems.plugnplay && plugnplay?.length">
                                    <ul class="offcanvas-submenu-list">
                                        <li class="offcanvas-submenu-list-item" v-for="item in plugnplay"
                                            :key="item.slug">
                                            <router-link :to="`/project/${item?.slug}`" @click="closeMobileMenu()"
                                                class="offcanvas-submenu-link">{{
                                                    item?.name }}</router-link>
                                        </li>
                                    </ul>
                                </ul>
                            </li>
                        </ul>
                    </div>

                    <!-- Discover Section -->
                    <!-- <div class="offcanvas-section">
                     <h6 class="offcanvas-section-title">Discover</h6>
                     <ul class="offcanvas-menu">
                         <li class="offcanvas-menu-item">
                             <router-link to="/projects" @click="closeMobileMenu" class="offcanvas-menu-link">
                                 <i class="ri-search-line"></i>
                                 <span>Discover activities</span>
                             </router-link>
                         </li>
                     </ul>
                 </div> -->

                    <!-- Resources Section -->
                    <div class="offcanvas-section">
                        <h6 class="offcanvas-section-title">Resources</h6>
                        <ul class="offcanvas-menu">
                            <li class="offcanvas-menu-item">
                                <router-link to="/resources" @click="closeMobileMenu" class="offcanvas-menu-link">
                                    <i class="ri-book-open-line"></i>
                                    <span>Blogs</span>
                                </router-link>
                            </li>


                            <li class="offcanvas-menu-item">
                                <router-link to="/project/build-with-meander" @click="closeMobileMenu" class="offcanvas-menu-link">
                                    <i class="ri-tools-line"></i>
                                    <span>Build</span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </aside>
        </transition>
    </div>
</template>
<style scoped>
.nav-item a {
    white-space: normal !important;
}
</style>
<script>
import { Search_APP, GET_INTEGRATION, GET_NAV_MENU_DATA } from '../../services/graphqlService';
import apolloClient from "../../apollo";
import { watchEffect } from 'vue';
export default {
    name: 'Navbar',
    props: {
        openPopup: Function
    },
    data() {
        return {
            hideSearchTimeout: null,
            isSticky: true, //it was false and now temporary true 
            isMenu: false,
            isContect: true,
            active: false,
            button_active_state: false,
            appCategories: [],
            technologiesCategories: [],
            services: [],
            industries: [],
            products: [],
            integration: [],
            plugnplay: [],
            baseUrl: 'https://content.meander.software',
            showAside: false, // Added to control aside visibility
            searchQuery: '',
            showSearchResults: false,
            allowedCategoriesOrder: [
                'Trending Apps',
                'Popular Apps',
                'On Demand Apps',
                'Business Apps',
                'Social Apps',
            ],
            filteredApps: [],
            allApps: [], // Will store all apps from categories
            // Mobile accordion states
            expandedMenuItems: {
                models: false,
                products: false,
                integration: false,
                plugnplay: false
            },
            // Store scroll event listeners for proper cleanup
            scrollListeners: {
                home: null,
                projects: null
            }
        }
    },
    computed: {
        sortedAppCategories() {
            return this.allowedCategoriesOrder
                .map(name => this.appCategories.find(cat => cat.name === name))
                .filter(Boolean); // removes undefined if category not found
        },
        sortedProducts() {
            if (!this.products) return [];
            return this.products.filter(p => p.name && !p.name.toLowerCase().includes('build'));
        },
        isHomePage() {
            return this.$route.path === '/';
        },
        isProjectsPage() {
            return this.$route.path === '/projects';
        }
    },
    watch: {
        '$route.path'(newPath) {
            // Remove existing listeners first
            this.removeScrollListeners();

            if (newPath === '/') {
                // On home, use scroll logic with default 550px
                this.handleScroll(550);
                this.scrollListeners.home = () => this.handleScroll(550);
                window.addEventListener('scroll', this.scrollListeners.home);
            } else if (newPath === '/projects') {
                // On projects page, use 400px threshold
                this.handleScroll(400);
                this.scrollListeners.projects = () => this.handleScroll(400);
                window.addEventListener('scroll', this.scrollListeners.projects);
            } else {
                // On other pages, always show aside
                this.showAside = true;
            }
        }
    },
    async mounted() {
        // Fetch all navigation data in parallel to reduce TBT
        await Promise.all([
            this.GetIntegration(),
            this.GetPlugnPlay(),
            this.getNavMenuData()
        ]);
        if (this.isHomePage) {
            this.scrollListeners.home = () => this.handleScroll(550);
            window.addEventListener('scroll', this.scrollListeners.home);
            this.handleScroll(550); // Set initial state with default 550px
        } else if (this.isProjectsPage) {
            this.scrollListeners.projects = () => this.handleScroll(400);
            window.addEventListener('scroll', this.scrollListeners.projects);
            this.handleScroll(400); // Set initial state with 400px
        } else {
            this.showAside = true;
        }
    },
    beforeUnmount() {
        this.removeScrollListeners();
    },
    methods: {
        removeScrollListeners() {
            if (this.scrollListeners.home) {
                window.removeEventListener('scroll', this.scrollListeners.home);
                this.scrollListeners.home = null;
            }
            if (this.scrollListeners.projects) {
                window.removeEventListener('scroll', this.scrollListeners.projects);
                this.scrollListeners.projects = null;
            }
        },
        handleSearchIconClick() {
            this.isContect = false; 

            // Start 3-second timer
            this.hideSearchTimeout = setTimeout(() => {
                if (!this.searchQuery.trim()) {
                    this.isContect = true;
                }
            }, 3000);
        },
        handleScroll(height = 550) {
            let scrollPos = window.scrollY
            if (scrollPos >= 100) {
                this.isSticky = true
            } else {
                this.isContect = true
                this.isSticky = true //it was false and now temporary true 
            }
            this.showAside = scrollPos >= height; // Show aside after specified height
        },

        async getNavMenuData() {
            try {
                //console.log('Loading navigation menu data...');

                const result = await apolloClient.query({
                    query: GET_NAV_MENU_DATA
                });

                if (result.data) {
                    const data = result.data;

                    if (data.businessModelCategories?.length) {
                        this.appCategories = data.businessModelCategories;
                        //console.log('App categories loaded:', this.appCategories);
                        this.extractAllApps(); // Extract all apps for search
                    }
                    if (data.products?.length) {
                        this.products = data.products;
                        //console.log('Products loaded:', this.products);
                    }
                    if (data.services?.length) {
                        this.services = data.services;
                        //console.log('Services loaded:', this.services);
                    }
                    if (data.industries?.length) {
                        this.industries = data.industries;
                        //console.log('Industries loaded:', this.industries);
                    }
                    if (data.technologiesCategories?.length) {
                        this.technologiesCategories = data.technologiesCategories;
                        //console.log('Technologies categories loaded:', this.technologiesCategories);
                    }
                }

            } catch (error) {
                console.error("Error fetching navigation menu data:", error);

                // Handle different types of errors
                if (error.networkError) {
                    console.error("Network error:", error.networkError);
                }
                if (error.graphQLErrors) {
                    console.error("GraphQL errors:", error.graphQLErrors);
                }
            }
        },

        //local storage-------->
        setAppsInLocalStorage(newApps) {
            try {
                // const filteredApps = newApps?.attributes?.related_apps?.data.filter(app => app?.attributes?.isadd);
                // Remove existing data
                localStorage.removeItem('relatedApps');

                // Save new data
                localStorage.setItem('relatedApps', JSON.stringify(newApps));
            } catch (error) {
                console.error(error);
                console.error('Error setting data in local storage:', error);
            }
        },
        // setproductsInLocalStorage(newproducts) {
        //     try {
        //         // Remove existing data
        //         localStorage.removeItem('relatedproducts');

        //         // Save new data
        //         localStorage.setItem('relatedproducts', JSON.stringify(newproducts));
        //     } catch (error) {
        //         console.error(error);
        //         console.error('Error setting data in local storage:', error);
        //     }
        // },
        settechologiesInLocalStorage(newtechologies) {
            try {
                // Remove existing data
                localStorage.removeItem('relatedTechologies');

                // Save new data
                localStorage.setItem('relatedTechologies', JSON.stringify(newtechologies));
            } catch (error) {
                console.error(error);
            }
        },
        setIndustriesInLocalStorage(newIndustries) {
            try {
                // Remove existing data
                localStorage.removeItem('newIndustries');

                // Save new data
                localStorage.setItem('newIndustries', JSON.stringify(newIndustries));
            } catch (error) {
                console.error(error);
            }
        },
        setServiceInLocalStorage(newservice) {
            try {
                // Remove existing data
                localStorage.removeItem('newservice');

                // Save new data
                localStorage.setItem('newservice', JSON.stringify(newservice));
            } catch (error) {
                console.error(error);
            }
        },

        // Search functionality methods
        async handleSearch() {
            clearTimeout(this.hideSearchTimeout);
            if (this.searchQuery.trim() === '') {
                this.filteredApps = [];
                return;
            }
            const query = this.searchQuery.toLowerCase();
            const variables = {
                "filters": {
                    "or": [
                        {
                            "clone_synonyms": {
                                "containsi": query
                            }
                        },
                        {
                            "alias_synonyms": {
                                "containsi": query
                            }
                        },
                        {
                            "keywords": {
                                "containsi": query
                            }
                        },
                        {
                            "name": {
                                "containsi": query
                            }
                        },
                        {
                            "description": {
                                "containsi": query
                            }
                        },
                    ]

                },
                pagination: { page: 1, pageSize: 100 }
            }
            const { data } = await apolloClient.query({
                query: Search_APP,
                variables
            })
            watchEffect(() => {

                this.filteredApps = data?.apps

            });


        },


        handleBlur() {
            // Delay hiding results to allow click events to fire
            setTimeout(() => {
                this.showSearchResults = false;
            }, 200);
            setTimeout(() => {
                this.isContect = true;
            }, 200);
        },

        navigateToApp(slug) {
            this.showSearchResults = false;
            this.searchQuery = '';
            this.$router.push(`/project/${slug}`);
        },

        // Mobile accordion methods
        toggleAccordion(menuKey) {
            this.expandedMenuItems[menuKey] = !this.expandedMenuItems[menuKey];
        },

        toggleMobileMenu() {
            this.active = !this.active;
            this.button_active_state = this.active;
            // Prevent body scroll when menu is open
            if (this.active) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        },

        closeMobileMenu() {
            this.active = false;
            this.button_active_state = false;
            document.body.style.overflow = '';
            // Reset all accordion states
            Object.keys(this.expandedMenuItems).forEach(key => {
                this.expandedMenuItems[key] = false;
            });
        },

        // Extract all apps from categories
        extractAllApps() {
            this.allApps = [];
            if (this.appCategories && this.appCategories.length > 0) {
                this.appCategories.forEach(category => {
                    if (category.business_models && category.business_models.length > 0) {
                        category.business_models.forEach(app => {
                            this.allApps.push({
                                name: app.name,
                                slug: app.slug
                            });
                        });
                    }
                });
            }
        },

        async GetIntegration() {
            try {


                const variables = {
                    filters: {
                        type: {
                            eq: 'Integration'
                        }
                    }
                };

                const result = await apolloClient.query({
                    query: GET_INTEGRATION,
                    variables: variables
                });

                if (result.data && result.data.apps) {
                    //console.log('Integration data loaded:', result.data.apps);
                    // Process the integration data here
                    this.integration = result.data.apps || [];
                }

            } catch (error) {
                console.error("Error fetching integrations:", error);

                // Handle different types of errors
                if (error.networkError) {
                    console.error("Network error:", error.networkError);
                }
                if (error.graphQLErrors) {
                    console.error("GraphQL errors:", error.graphQLErrors);
                }

                // You can add user-friendly error messages here
                // this.showErrorMessage = "Failed to load integrations. Please try again.";
            }
        },
        async GetPlugnPlay() {
            try {


                const variables = {
                    filters: {
                        plugNPlay: {
                            eq: true
                        }
                    }
                };

                const result = await apolloClient.query({
                    query: GET_INTEGRATION,
                    variables: variables
                });

                if (result.data && result.data.apps) {
                    //console.log('Plugnplay data loaded:', result.data.apps);
                    // Process the integration data here
                    this.plugnplay = result.data.apps || [];
                }

            } catch (error) {
                console.error("Error fetching plugnplay:", error);

                // Handle different types of errors
                if (error.networkError) {
                    console.error("Network error:", error.networkError);
                }
                if (error.graphQLErrors) {
                    console.error("GraphQL errors:", error.graphQLErrors);
                }

                // You can add user-friendly error messages here
                // this.showErrorMessage = "Failed to load integrations. Please try again.";
            }
        },



    }
}
</script>

<style scoped>
.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: opacity 0.4s, max-height 0.4s, margin 0.4s, padding 0.4s;
    overflow: hidden;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
    opacity: 0;
    max-height: 0;
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
}

.fade-slide-enter-to,
.fade-slide-leave-from {
    opacity: 1;
    max-height: 200px;
    /* adjust as needed for your aside's height */
    margin-top: 0.5rem;
    /* or your normal margin */
    margin-bottom: 0.5rem;
    padding-top: 1rem;
    /* or your normal padding */
    padding-bottom: 1rem;
}

/* Responsive logo styling */
@media (max-width: 500px) {
    .navbar-brand img {
        width: 120px;
        height: auto;
    }
}

/* Contact button positioning for small screens */
@media only screen and (max-width: 500px) {
    .navbar-area .meander_software-nav .navbar .others-option {
        top: 0px !important;
        left: 150px !important;
    }
}

/* Search functionality styles */
.search-container {
    position: relative;
    display: block;
    width: 100%;
}

.Sreach-icon {
    font-size: 25px;
    color: #ffffff;
    float: right;
}

.bg-tran {
    background-color: transparent !important;
}

.search-results-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    max-height: 400px;
    overflow-y: auto;
    z-index: 1000;
    margin-top: 2px;
}

.search-result-item {
    padding: 10px 15px;
    cursor: pointer;
    border-bottom: 1px solid #f0f0f0;
    transition: background-color 0.2s ease;
}

.search-result-item:hover {
    background-color: #f8f9fa;
}

.search-result-item:last-child {
    border-bottom: none;
}

/* Mobile responsive adjustments */
@media (max-width: 768px) {
    .search-results-dropdown {
        max-height: 300px;
    }
}

/* Mobile Offcanvas Styles */
.mobile-offcanvas-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1040;
    backdrop-filter: blur(2px);
}

.mobile-offcanvas {
    position: fixed;
    top: 0;
    right: 0;
    width: 85%;
    max-width: 400px;
    height: 100vh;
    background: #101720;
    z-index: 1041;
    display: flex;
    flex-direction: column;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.3);
    overflow-y: auto;
}

.offcanvas-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    position: sticky;
    top: 0;
    background: #101720;
    z-index: 10;
}

.offcanvas-logo {
    display: flex;
    align-items: center;
}

.offcanvas-logo img {
    height: 35px;
    width: auto;
    filter: brightness(0) invert(1);
}

.offcanvas-close {
    background: transparent;
    border: none;
    font-size: 24px;
    color: #ffffff;
    cursor: pointer;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    transition: all 0.3s ease;
}

.offcanvas-close:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #ED2775;
}

.offcanvas-body {
    flex: 1;
    padding: 20px;
    overflow-y: auto;
}

.offcanvas-section {
    margin-bottom: 30px;
}

.offcanvas-section-title {
    font-size: 14px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 15px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.offcanvas-menu {
    list-style: none;
    padding: 0;
    margin: 0;
}

.offcanvas-menu-item {
    margin-bottom: 5px;
}

.offcanvas-menu-link {
    display: flex;
    align-items: center;
    padding: 12px 15px;
    color: #ffffff;
    text-decoration: none;
    border-radius: 8px;
    transition: all 0.3s ease;
    font-size: 15px;
    font-weight: 500;
    gap: 12px;
}

.offcanvas-menu-link i:first-child {
    font-size: 20px;
    color: #ED2775;
    width: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.offcanvas-menu-link:hover {
    background: linear-gradient(44.44deg, rgba(237, 39, 117, 0.2) 7.79%, rgba(255, 116, 72, 0.2) 94.18%);
    color: #ffffff;
}

.offcanvas-menu-link.router-link-active {
    background: linear-gradient(44.44deg, rgba(237, 39, 117, 0.3) 7.79%, rgba(255, 116, 72, 0.3) 94.18%);
    color: #ffffff;
}

.offcanvas-menu-link.active-expanded {
    background: linear-gradient(44.44deg, #ED2775 7.79%, #FF7448 94.18%);
    color: #ffffff;
}

.offcanvas-menu-link.active-expanded i {
    color: #ffffff;
}

.offcanvas-submenu {
    list-style: none;
    padding: 0;
    margin: 8px 0 0 36px;
    border-left: 2px solid rgba(255, 255, 255, 0.15);
    padding-left: 15px;
    animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
    from {
        opacity: 0;
        max-height: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        max-height: 1000px;
        transform: translateY(0);
    }
}

.offcanvas-submenu-title {
    font-size: 13px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.7);
    margin: 15px 0 10px 0;
    padding-bottom: 8px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.offcanvas-submenu-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.offcanvas-submenu-list li {
    margin-bottom: 8px;
}

.offcanvas-submenu-list-item {
    margin-bottom: 6px;
}

.offcanvas-submenu-link {
    display: block;
    padding: 10px 12px;
    color: rgba(255, 255, 255, 0.85);
    text-decoration: none;
    font-size: 14px;
    border-radius: 6px;
    transition: all 0.3s ease;
    position: relative;
    padding-left: 20px;
}

.offcanvas-submenu-link::before {
    content: '';
    position: absolute;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 4px;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 50%;
    transition: all 0.3s ease;
}

.offcanvas-submenu-link:hover {
    background: rgba(237, 39, 117, 0.15);
    color: #ffffff;
    padding-left: 24px;
}

.offcanvas-submenu-link:hover::before {
    background: #ED2775;
    width: 6px;
    height: 6px;
}

.offcanvas-submenu-link.router-link-active {
    background: rgba(237, 39, 117, 0.2);
    color: #ffffff;
    padding-left: 24px;
}

.offcanvas-submenu-link.router-link-active::before {
    background: #ED2775;
    width: 6px;
    height: 6px;
}

.offcanvas-submenu-list a {
    display: block;
    padding: 8px 12px;
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-size: 14px;
    border-radius: 6px;
    transition: all 0.3s ease;
}

.offcanvas-submenu-list a:hover {
    background: rgba(237, 39, 117, 0.2);
    color: #ffffff;
    padding-left: 16px;
}

.offcanvas-see-all {
    margin-top: 15px;
    padding-left: 0;
}

/* Offcanvas Transitions */
.offcanvas-enter-active,
.offcanvas-leave-active {
    transition: opacity 0.3s ease;
}

.offcanvas-enter-from,
.offcanvas-leave-to {
    opacity: 0;
}

.offcanvas-slide-enter-active {
    transition: transform 0.3s ease-out;
}

.offcanvas-slide-leave-active {
    transition: transform 0.3s ease-in;
}

.offcanvas-slide-enter-from {
    transform: translateX(100%);
}

.offcanvas-slide-leave-to {
    transform: translateX(100%);
}

/* Responsive adjustments */
@media (max-width: 480px) {
    .mobile-offcanvas {
        width: 90%;
    }

    .offcanvas-header {
        padding: 15px;
    }

    .offcanvas-body {
        padding: 15px;
    }
}

/* Premium Megamenu for Products styling */
@media (min-width: 992px) {
    .products-dropdown-menu {
        min-height: 352px;
    }
}
.border-start-custom {
    border-left: 1px solid rgba(0, 0, 0, 0.08);
}
@media (max-width: 991px) {
    .border-start-custom {
        border-left: none;
    }
    .mobile-divider {
        border-top: 1px solid rgba(0, 0, 0, 0.08);
        padding-top: 25px;
        margin-top: 10px;
    }
}

/* Image links inside Products Megamenu */
.product-img-link-new {
    display: block;
    margin-top: 15px;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.02);
}
.product-img-link-new:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
    border-color: rgba(237, 39, 117, 0.2);
}
.nav-product-img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
}
</style>